import { ClipLoader } from "react-spinners";

export default function Spinner({ size = 48, className = "h-full w-full" }) {
  return (
    <div className={`flex items-center justify-center ${className}`.trim()}>
      <ClipLoader color="#852170" size={size} />
    </div>
  );
}
